<template>
  <CRow>
    <CModal
        :title="
        submitType === 'Update'
          ? $lang.platform_ratting.crud.edit
          : $lang.platform_ratting.crud.create
      "
        size="lg"
        :show.sync="largeModal"
        :no-close-on-backdrop="true"
        color="primary"
    >
      <CAlert color="danger" closeButton :show.sync="dismissCountDown" fade>{{
          err_msg
        }}
      </CAlert>
      <CForm novalidate @submit.prevent="onSubmit">
        <CCardBody>
          <div
              class="form-group"
              :class="{ 'form-group--error': $v.platform_ratting.platform.$error }"
          >
            <label class="form__label"
            >{{ $lang.platform_ratting.form.platform }}
              <required_span/>
            </label>
            <input
                :maxlength="maxlength.platform"
                :placeholder="$lang.platform_ratting.form.platform"
                class="form-control"
                v-model="platform_ratting.platform"
            />
            <small
                class="error"
                v-if="$v.platform_ratting.platform.$error && !$v.platform_ratting.platform.required"
            >{{ $lang.platform_ratting.validation.required.platform }}</small
            >
            <small
                class="error"
                v-if="$v.platform_ratting.platform.$error && !$v.platform_ratting.platform.minLength"
            >{{ $lang.platform_ratting.validation.minLength.platform }}
              {{ $v.platform_ratting.platform.$params.minLength.min }}
              {{ $lang.platform_ratting.validation.common.letter }}</small
            >
          </div>

          <CRow>
            <CCol md="12">
              <label class="form__label"
              >{{ $lang.platform_ratting.form.logo }}
              </label>
              <div class="form-group" :class="{ 'form-group--error': '' }">
                <img :src="SRCIMAGE" v-if="SRCIMAGE" alt="Logo"/>
                <ImageCropper @profileImage="getProfile($event)"/>
              </div>
            </CCol>
          </CRow>

          <div class="form-group" :class="{ 'form-group--error': '' }">
            <label class="form__label"
            >{{ $lang.platform_ratting.form.isActive }}
            </label>
            <input
                type="checkbox"
                :placeholder="$lang.platform_ratting.form.isActive"
                :value="1"
                @change="changedIsActive"
                v-model="platform_ratting.isActive"
            />
          </div>
        </CCardBody>
        <CCardFooter>
          <CButton
              type="submit"
              size="sm"
              color="primary"
              :disabled="submitted"
          >
            <CIcon name="cil-check-circle"/>
            {{ $lang.buttons.general.crud.submit }}
          </CButton>
          &nbsp;
        </CCardFooter>
      </CForm>
      <template #footer style="display: none">
        <CButton @click="darkModal = false" color="danger" style="display: none"
        >Discard
        </CButton
        >
        <CButton
            @click="darkModal = false"
            color="success"
            style="display: none"
        >Accept
        </CButton
        >
      </template>
    </CModal>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <div class="row">
            <CCol sm="6" class="align-self-center">
              <strong>{{ $lang.platform_ratting.title }}</strong>
            </CCol>
            <CCol sm="6" class="align-self-center">
              <div class="text-sm-right mt-3 mt-sm-0">

                <CButton
                    color="primary"
                    v-on:click="createTableRow"
                    v-if="checkPermission('create-country')"
                    style="margin-right: 10px"
                >
                  {{ $lang.buttons.general.crud.create }}
                </CButton>

                <CButtonGroup class="file-export">
                  <CButton color="secondary" disabled>
                    {{ $lang.buttons.export.title }}
                  </CButton>
                  <CButton
                      color="danger"
                      v-c-tooltip="$lang.buttons.export.pdf"
                      v-on:click="exports(self, 'pdf', module, 'Platforms')"
                  >
                    <i class="fas fa-file-pdf"></i>
                  </CButton>
                  <VueJsonToCsv
                      class="btn btn-success"
                      v-c-tooltip="$lang.buttons.export.excel"
                      :json-data="json_data"
                      :labels="json_label"
                      :csv-title="json_title"
                  >
                    <i class="fas fa-file-excel"></i>
                  </VueJsonToCsv>
                </CButtonGroup>
              </div>
            </CCol>
          </div>
        </CCardHeader>
        <CCardBody>
          <CAlert
              :color="messageColor"
              closeButton
              :show.sync="dismissCountDownS"
              fade
          >{{ alertMessage }}
          </CAlert
          >
          <v-server-table
              :columns="columns"
              url="/website-ratting/list"
              :options="options"
              ref="myTable"
              @loaded="exports(self, 'Excel', module, 'Platforms')"
          >
            <template #status="data">
              <CBadge :color="statusBudget(data.row.status)">{{ data.row.status }}</CBadge>
            </template>

            <template #image="data">
              <Avatar
                  :image="data.row.image"
                  :content="data.row.platform"
                  :isProfileListPage="true"

              />
            </template>

            <template #actions="data">
              <CButton
                  color="success"
                  v-c-tooltip="$lang.buttons.general.crud.edit"
                  v-on:click="editTableRow(data.row.id)"
                  v-if="checkPermission('edit-country')"
              >
                <i class="fas fa-pencil-alt"></i>
              </CButton>
              <CButton
                  color="danger"
                  v-c-tooltip="$lang.buttons.general.crud.delete"
                  v-on:click="deletePopup(data.row.id)"
                  v-if="checkPermission('delete-country')"
              >
                <i class="fas fa-trash"></i>
              </CButton>
            </template>


          </v-server-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Vue from "vue";
import VueForm from "vue-form";
import {platformRatting} from "/src/store/url.js";
import {Mixin} from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import {ServerTable} from "vue-tables-2";
import VueSweetalert2 from "vue-sweetalert2";
import {minLength, required} from "vuelidate/lib/validators";
import required_span from "../../components/layouts/general/required-span";
import VueJsonToCsv from "vue-json-to-csv";
import {Maxlength} from "../../store/maxlength";
import ImageCropper from "../ImageCropper";
import Avatar from "/src/components/Avatar";
import {serverBus} from "../../main";

Vue.use(VueSweetalert2);
Vue.use(ServerTable, {}, false);
Vue.use(VueForm, options);

export default {
  name: "PlatformRatting",
  mixins: [Mixin],
  components: {
    required_span,
    VueJsonToCsv,
    ImageCropper,
    Avatar
  },
  data() {
    return {

      FILE: null,
      imgSrc: null,
      SRCIMAGE: null,
      existImage: false,
      imageURL: null,
      imageRemove: null,
      imageOutput: "",

      submitted: false,
      json_data: [],
      json_label: {},
      json_title: "",
      err_msg: "",
      largeModal: false,
      messageColor: "success",
      submitType: "",
      alertMessage: "test",
      showAlert: false,
      dismissCountDown: 0,
      dismissCountDownS: 0,
      self: this,
      msg: "",
      items: [],
      activePage: 1,
      module: platformRatting,
      platform_ratting: {
        platform: "",
        isActive: "",
        imageURL: "",
      },
      maxlength: {
        name: Maxlength.platform_ratting.platform,

      },
      columns: ["image", "platform", "status"],
      data: [],
      options: {
        headings: {
          platform: this.$lang.platform_ratting.table.platform,
          image: this.$lang.platform_ratting.table.logo,
          status: this.$lang.platform_ratting.table.isActive,
        },
        sortable: ["platform"],
        filterable: ["platform"],
      },
    };
  },
  validations: {
    platform_ratting: {
      platform: {
        required,
        minLength: minLength(1),
      },
    },
  },
  created() {
    if (
        this.checkPermission("edit-website-ratting") === true ||
        this.checkPermission("delete-website-ratting") === true
    ) {
      this.columns.push("actions");
    }
  },
  mounted() {
    let self = this;
    // this.loadData();
    self.dismissCountDown = 0;
    self.dismissCountDownS = 0;
    if (localStorage.getItem("showAlert") !== "") {
      this.setAlert(true);
    }
    this.setAlert(false);
    localStorage.setItem("showAlert", "");
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  methods: {
    getProfile(profile) {
      let self = this;
      self.platform_ratting.imageURL = profile;
      if (profile === "") {
        self.platform_ratting.imageRemove = 1;
      } else {
        self.platform_ratting.imageRemove = 0;
      }
    },
    changedIsActive(e) {
      let self = this;
      this.v = e.target.checked;
      if (this.v) {
        self.platform_ratting.isActive = 1;
      } else {
        self.platform_ratting.isActive = 0;
      }
    },
    setAlert(value) {
      this.showAlert = value;
    },
    deletePopup(item) {
      this.$swal({
        title: this.$lang.common.delete_swal.are_you,
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#e55353",
        confirmButtonText: this.$lang.common.delete_swal.yes_delete,
        cancelButtonText: this.$lang.common.delete_swal.cancel,
      }).then((result) => {
        if (result.value) {
          let self = this;
          axios
              .delete(this.deleteUrlWeb(this.module, item), self)
              .then(function (response) {
                let responseData = response.data.data;
                if (response.data.status === 200) {
                  self.$refs.myTable.refresh();
                  self.messageColor = "success";
                  self.alertMessage = responseData.message;
                  self.dismissCountDownS = 10;
                } else {
                  self.$refs.myTable.refresh();
                  self.alertMessage = responseData.message;
                  self.messageColor = "danger";
                  self.dismissCountDownS = 10;
                }
              }).catch(function (error) {
            let data;
            if (error.response.data.error) {
              data = error.response.data.error.toString();
            } else {
              data = error.response.data.message;
            }
            self.alertMessage = data;
            self.messageColor = "danger";
            self.dismissCountDownS = 10;
          });
        }
      });
    },
    createTableRow() {
      let self = this;
      self.$v.$reset();
      self.submitType = "Create";
      self.platform_ratting.platform = "";
      self.platform_ratting.isActive = 1;
      self.platform_ratting.isActive = 1;
      serverBus.$emit("send_cropper_image_url", '');
      self.largeModal = true;
    },
    editTableRow(item) {
      let self = this;
      self.$v.$reset();
      self.submitType = "Update";
      const id = item;
      self.editId = item;
      axios
          .get(this.viewUrlApi(this.module, id), self.model)
          .then(function (response) {
            if (response) {
              let responseData = response.data.data;
              self.platform_ratting.platform = responseData.platform;
              self.platform_ratting.isActive = responseData.isActive;
              if (responseData.image !== "") {
                serverBus.$emit("send_cropper_image_url", responseData.image);
                self.existImage = true;
              }
            } else {
              self.data = [];
            }
          });
      self.largeModal = true;
    },
    rowClicked(item) {
      this.$router.push({path: `country/view/${item}`});
    },
    pageChange(val) {
      this.$router.push({query: {page: val}});
    },
    loadData() {
      let self = this;
      axios
          .get(this.listUrlApi(this.module), self.model)
          .then(function (response) {
            if (response) {
              self.data = response.data;
            } else {
              self.data = [];
            }
          });
    },
    onSubmit() {
      let self = this;
      this.$v.platform_ratting.$touch();
      if (this.$v.platform_ratting.$invalid) {
        self.submitted = false; //Enable Button
        this.submitStatus = "ERROR";
      } else {
        self.submitted = true; //Disable Button
        this.submitStatus = "PENDING";
        if (this.submitType === "Update") {
          setTimeout(() => {
            let self = this;
            const formData = new FormData();
            formData.append("image", self.platform_ratting.imageURL);
            formData.append("platform", self.platform_ratting.platform);
            formData.append("isActive", self.platform_ratting.isActive);
            axios
                .post(this.updateUrlweb(this.module, self.editId), formData)
                .then(function (response) {
                  self.submitted = false; //Enable Button
                  if (response.data.code === 200) {
                    self.largeModal = false;
                    self.$refs.myTable.refresh();
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.messageColor = "success";
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  let data;
                  if (error.response.data.error) {
                    data = error.response.data.error.toString();
                  } else {
                    data = error.response.data.message;
                  }
                  self.err_msg = data;
                  self.dismissCountDown = 10;
                  self.submitted = false; //Enable Button
                });
          }, 500);
        } else {
          setTimeout(() => {
            let self = this;
            const formData = new FormData();
            formData.append("image", self.platform_ratting.imageURL);
            formData.append("platform", self.platform_ratting.platform);
            formData.append("isActive", self.platform_ratting.isActive);
            axios
                .post(this.createUrlWeb(this.module), formData)
                .then(function (response) {
                  self.submitted = false; //Enable Button
                  if (response.data.code === 200) {
                    self.alertMessage = response.data.message;
                    self.dismissCountDownS = 10;
                    self.largeModal = false;
                    self.messageColor = "success";
                    self.$refs.myTable.refresh();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  let data;
                  if (error.response.data.error) {
                    data = error.response.data.error.toString();
                  } else {
                    data = error.response.data.message;
                  }
                  self.err_msg = data;
                  self.dismissCountDown = 10;
                  self.submitted = false; //Enable Button
                });
          }, 500);
        }
      }
    },
  },
};
</script>
